import { render } from "./Avatar3DPicker.vue?vue&type=template&id=20d525fc&scoped=true"
import script from "./Avatar3DPicker.vue?vue&type=script&lang=js"
export * from "./Avatar3DPicker.vue?vue&type=script&lang=js"

import "./Avatar3DPicker.vue?vue&type=style&index=0&id=20d525fc&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d525fc"]])

export default __exports__